import { createAsyncThunk } from "@reduxjs/toolkit";

import { getProducts } from "../../../api/reviews";
import { IReviewsBrandID } from "../../../models/nominals";
import { IReviewsProduct } from "../../../models/reviews";

/**
 * Load all products for a brand.
 *
 * Fetches the complete list of products available for review for a given brand.
 * Used to populate product selection dropdowns in write review forms.
 *
 * @param {IReviewsBrandID} brandID - The brand identifier to load products for
 *
 * @returns {Promise<IReviewsProduct[]>} Promise resolving to array of products
 *
 * @example
 * // Load all Tempur-Pedic products
 * dispatch(loadProducts('tempur-pedic'));
 *
 * @sideEffects
 * - Updates `data.products` with fetched products via extraReducers
 * - Sets `data.loadedInitialProducts` to true via extraReducers
 */
export const loadProducts = createAsyncThunk(
    "reviews/loadProducts",
    async (brandID: IReviewsBrandID): Promise<readonly IReviewsProduct[]> => {
        const products = await getProducts(brandID);
        return products;
    },
);
